import { service } from '@/utils/request'

export default {
  getDataList(params) {
    return service({
      url: "/cloud/dvoice/v1/medical/qa/entity/list",
      method: "get",
      params
    });
  },
  getDetail(id) {
    return service({
      url: `/cloud/dvoice/v1/medical/qa/entity/detail/${id}`,
      method: "get"
    });
  },
  add(data) {
    return service({
      url: "/cloud/dvoice/v1/medical/qa/entity/add",
      method: "post",
      data
    });
  },
  update(data) {
    return service({
      url: "/cloud/dvoice/v1/medical/qa/entity/update",
      method: "post",
      data
    });
  },
  deleteById(id) {
    return service({
      url: `/cloud/dvoice/v1/medical/qa/entity/delete/${id}`,
      method: "post"
    });
  },
  importUser(params) {
    return service({
      url: "/cloud/dvoice/v1/medical/qa/user/import",
      method: "post",
      params
    });
  },
  getUserList(params) {
    return service({
      url: "/cloud/dvoice/v1/medical/qa/user/list",
      method: "get",
      params
    });
  },
  exportUserList(params) {
    return service({
      url: "/cloud/dvoice/v1/medical/qa/user/list/export",
      method: "get",
      params,
      responseType: 'blob'
    });
  }
};


// WEBPACK FOOTER //
// ./src/api/contentManage/questionAnswer.js